import React, { useState, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import jwtDecode from 'jwt-decode';
import Image from 'next/image';
//antd imports
import { Drawer, Modal, Form, Skeleton } from 'antd';

//custom component imports
import { IsUserLoggedIn } from './v2/Layout';
import Title from '../components/Title/title';
import Input from '../components/Input/CustomInput';
import Button from '../components/Button/CustomButton';
import TransactionCard from '../components/TransactionCard/index';

//redux helper functions imports
import {
    updateUserObj,
    updateEmail,
    updatePhone,
    updateCompanyLogo,
    updateShowBillzyLogo,
} from '../slice/paymentsSlice';

//helper functions imports
import { getDecryptedMobileNumber } from '../utils/encryption';
import {
    clearUserDataFromStorage,
    localStorageKeys,
    // menuItemList,
    sessionStorageKeys,
} from '../utils';
import { post, get } from '../utils/apiService';
import { setBillInSessionStorage } from '../utils/transactionFunc';
import {
    getErrorNotification,
    getInfoNotification,
    loginApiBase,
} from '../utils/apiServiceHelpers';
import { setDeeplinkTokenForOrder } from '../utils/tokenHandling';
import {
    EventProperites,
    handlEvents,
    MixPanelCategory,
    MixPanelCTA,
    MixPanelEvents,
} from '../lib/mixPanel';
import { APIS } from '../helpers/constants';
import HomeCorousel from '../components/HomeCorousel';
import howItWorksMobile from '../public/howitworksmobile.svg';
import howItWorksDesktop from '../public/howitworks.svg';
import warrningIconSVG from '../public/warrningIcon.svg';
import arrowForwardIsoFilledIcon from '../public/arrowForwardIsoFilledIcon.svg';
import checkedSquareSVG from '../public/checkedSquare.svg';
import sideChevronSVG from '../public/sideChevron.svg';

//css imports
import styles from './v2//Layout.module.css';
import homeStyles from './v2//home.module.css';
import { useDispatch } from 'react-redux';

const defaultStateValue = {
    loading: false,
    transactions: [],
    linked_loans: [],
    showAutoLoginPopup: false,
    isOtpDrawerOpen: false,
    isOtpModalOpen: false,
    isOtpValid: true,
    otpErrorMessage: '',
    otp: '',
    showLogoutConfirmation: false,
    btnLoadingState: false,
    userNumber: '',
    countsLeft: 0,
    checkPointers: [
        'Partial Payment Options',
        'Instant Issue Resolution',
        'Receive Bill Breakups for your Payments',
        'Track Past Fulfillments against your Accounts',
        'Subscribe for Recurring Auto-Debits',
    ],
    showLoans: false,
};
const Home = (props) => {
    const [state, setState] = useState(defaultStateValue);
    const [getRecentTransactionApiFlag, setGetRecentTransactionApiFlag] =
        useState(false);
    const router = useRouter();
    const context = useContext(IsUserLoggedIn);
    const {
        toggleLoginModalAndDrawer,
        toggleLoginCTA,
        userLoggedIn,
        fetchData,
        toggleLogin,
        onClickProceedLogin,
        clearUserData,
    } = context;
    const { isMobile } = props;
    const dispatch = useDispatch();

    const howItWorks = isMobile ? howItWorksMobile : howItWorksDesktop;

    useEffect(() => {
        const logo = '/billzy_logo.png';
        dispatch(updateCompanyLogo(logo));
        dispatch(updateShowBillzyLogo(false));
        sessionStorage.removeItem(sessionStorageKeys.COMPANY_LOGO);
        sessionStorage.removeItem(
            sessionStorageKeys.USER_SELECTED_CREDITLINE_DATA
        );
        sessionStorage.removeItem(sessionStorageKeys.MANUAL_CHECKED_KEYS);
        sessionStorage.removeItem(sessionStorageKeys.MANUAL_CHECKED_AMOUNT);
        toggleLoginCTA(true);
        sessionStorage.setItem(sessionStorageKeys.SHOW_LOGIN_CTA, true);
        const displayLoginPopup = Boolean(
            JSON.parse(
                sessionStorage.getItem(sessionStorageKeys.LOGIN_POPUP)
            ) || false
        );
        if (displayLoginPopup) {
            toggleLoginModalAndDrawer(true);
        }

        if (userLoggedIn) {
            getRecentTransaction();
        }
        document.title = `Make secure payments | Billzy`;
        sessionStorage.removeItem(sessionStorageKeys.FLOW_TYPE);
        sessionStorage.removeItem(sessionStorageKeys.CUSTOMER_DETAILS);
        const loginNudgeShown =
            sessionStorage.getItem(sessionStorageKeys.LOGIN_NUDGE_SHOW) ||
            false;
        if (!userLoggedIn && !loginNudgeShown) {
            showLoginNudge();
            sessionStorage.setItem(sessionStorageKeys.LOGIN_NUDGE_SHOW, '1');
        }

        if (
            sessionStorage.getItem(sessionStorageKeys.IS_AUTO_LOGIN) ===
                'true' &&
            !localStorage.getItem(localStorageKeys.ACCESS_TOKEN)
        ) {
            setState((prevState) => ({
                ...prevState,
                showAutoLoginPopup: true,
                isOtpDrawerOpen: isMobile,
                isOtpModalOpen: !isMobile,
            }));
        }
        // checking if second user data is present or not before asking logging out consent
        else if (getDecryptedMobileNumber(localStorageKeys.SECOND_USER_PHONE)) {
            setState((prevState) => ({
                ...prevState,
                showLogoutConfirmation: true,
            }));
        }

        window.addEventListener('popstate', () => {
            window.history.pushState(
                null,
                document.title,
                window.location.href
            );
        });
    }, []);

    useEffect(() => {
        if (state.showAutoLoginPopup) autoLogin();
    }, [state.showAutoLoginPopup]);

    useEffect(() => {
        if (fetchData && !getRecentTransactionApiFlag) {
            getRecentTransaction();
            setGetRecentTransactionApiFlag(true);
        }
    }, [getRecentTransactionApiFlag, fetchData]);

    const showLoginNudge = () => {
        getInfoNotification(
            'Login now to make and track your payments on billzy.'
        );
    };

    const getLinkedLoans = async () => {
        setState((prevState) => ({ ...prevState, loading: true }));
        try {
            const response = await get({
                endPoint: APIS.LINKED_LOANS,
                sendAuthHeader: true,
                version: 'v2',
            });
            setState((prevState) => ({
                ...prevState,
                linked_loans: response?.loan_data || [],
            }));
        } catch (error) {
            getErrorNotification(error);
        } finally {
            setState((prevState) => ({ ...prevState, loading: false }));
        }
    };

    const getRecentTransaction = async () => {
        try {
            const response = await get({
                endPoint: `${APIS.TRANSACTIONS_LIST}?page_number=1&page_size=1000`,
                sendAuthHeader: true,
                version: 'v2',
            });
            setState((prevState) => ({
                ...prevState,
                transactions: response?.transaction_data || [],
            }));
        } catch (error) {
            getErrorNotification(error);
        }
    };

    const checkAndPay = async (loan) => {
        try {
            const response = await post({
                endPoint: APIS.LINKED_LOANS,
                payload: {
                    ...loan,
                    allocation_dpd_value: loan?.allocation_dpd_value || '',
                },
                responseType: 'json',
                sendAuthHeader: true,
                version: 'v2',
            });
            sessionStorage.setItem(
                sessionStorageKeys.ADVANCE_PAYMENT_AVAILABLE,
                JSON.stringify(
                    response?.['advance_payment_available'] !== undefined
                        ? response['advance_payment_available']
                        : true
                )
            );
            await setDeeplinkTokenForOrder(
                localStorage.getItem(localStorageKeys.ACCESS_TOKEN),
                response?.bill_data?.enc_refId || response?.enc_order_id,
                false
            );
            await setBillInSessionStorage(
                response,
                response?.bill_data?.enc_refId || response?.enc_order_id
            );

            if (response?.company_logo_url) {
                dispatch(updateCompanyLogo(response?.company_logo_url));
                sessionStorage.setItem(
                    sessionStorageKeys.COMPANY_LOGO,
                    response.company_logo_url
                );
            }

            router.push('/v2/billInfo?goBack=true&bckUrl=true&itemIndex=0');
        } catch (error) {
            getErrorNotification(error);
        }
    };

    // NOSONAR
    // const renderReleasedItems = () => {
    //     return menuItemList?.map((item, index) => {
    //         if (item?.apiKey !== 'LOAN' && item?.isReleased === true) {
    //             return (
    //                 <div
    //                     key={`${item.apiKey}_${index + 1}`}
    //                     className={`${homeStyles.menuItem}`}
    //                     onClick={() => {
    //                         redirectToRenderScreen(item, index);
    //                     }}
    //                 >
    //                     <Image
    //                         src={item.logo}
    //                         className={`${styles.categoryIcon}`}
    //                         alt="categoryIcon-image"
    //                     ></Image>
    //                 </div>
    //             );
    //         }
    //     });
    // };
    // const redirectToRenderScreen = (item, index) => {
    //     sessionStorage.setItem(sessionStorageKeys.BILLER_CATEGORY, item.apiKey);
    //     //remove data of old selected category (if present)
    //     sessionStorage.removeItem(sessionStorageKeys.SELECTED_BILLER);
    //     sessionStorage.removeItem(sessionStorageKeys.CUSTOMER_DETAILS);
    //     sessionStorage.removeItem(sessionStorageKeys.ALLOWED_PAYMENT_MODES);
    //     sessionStorage.removeItem(sessionStorageKeys.NET_BANKING_LIST);
    //     window.location.href = `/v2/operator?category=${item.apiKey}&itemIndex=${index}&bckUrl=/home`;
    // };

    const renderStaticPagesContainer = () => {
        return (
            <div className={homeStyles.staticPagesContainer}>
                <div className={homeStyles.staticPagesItem}>
                    <a
                        href="/tnc?bckUrl=/home"
                        onClick={() => {
                            handlEvents({
                                events: MixPanelEvents.Billzy_Home_Terms_and_condition,
                                module: EventProperites['Terms and condition'],
                                category: MixPanelCategory.Exprience,
                                cta: MixPanelCTA.click,
                            });
                        }}
                    >
                        Terms and Conditions
                    </a>
                </div>
                <div className={homeStyles.staticPagesItem}>|</div>
                <div className={homeStyles.staticPagesItem}>
                    <a
                        href="/about-contact?bckUrl=/home"
                        onClick={() => {
                            handlEvents({
                                events: MixPanelEvents.Billzy_Home_About_us,
                                module: EventProperites['Home Page - About us'],
                                category: MixPanelCategory.Exprience,
                                cta: MixPanelCTA.click,
                            });
                        }}
                    >
                        About Us
                    </a>
                </div>
                <div className={homeStyles.staticPagesItem}>|</div>
                <div className={homeStyles.staticPagesItem}>
                    <a
                        href="/faq?bckUrl=/home"
                        onClick={() => {
                            handlEvents({
                                events: MixPanelEvents.Billzy_Home_FAQs,
                                module: EventProperites['Home page - FAQs'],
                                category: MixPanelCategory.Exprience,
                                cta: MixPanelCTA.click,
                            });
                        }}
                    >
                        FAQs
                    </a>
                </div>
            </div>
        );
    };

    const redirectToTranscations = () => {
        router.push('/v2/transactionHistory?bckUrl=true&goBack=true');
        handlEvents({
            events: MixPanelEvents['Billzy_Recent_Transaction_View_all_'],
            module: EventProperites['Billzy-View-all-dropdown'],
            category: MixPanelCategory.Exprience,
            cta: MixPanelCTA.click,
        });
    };

    const autoLogin = async (type = '') => {
        let bill = JSON.parse(sessionStorage.getItem(sessionStorageKeys.BILL));
        const accessToken = bill?.enc_refId;
        let order_id_token = JSON.parse(sessionStorage.getItem(accessToken));
        const decodedTokenVal = jwtDecode(order_id_token?.deeplinkToken);
        let payload = {
            identity_value: decodedTokenVal?.applicant_contact_number,
        };
        if (type === 'otp') payload = { ...payload, otp: state.otp };

        try {
            const response = await post({
                endPoint: APIS.LOGIN_API,
                payload: payload,
                responseType: 'json',
                useLoginApiBase: true,
            });

            setState((prevState) => ({
                ...prevState,
                countsLeft: response?.otp_retries_left || 0,
            }));

            if (response?.access_token) {
                localStorage.setItem(
                    localStorageKeys.ACCESS_TOKEN,
                    response?.access_token
                );
                getRecentTransaction();
            }

            if (type === 'otp') {
                toggleLogin();

                try {
                    const responseProfile = await get({
                        endPoint: `${loginApiBase}${APIS.USER_PROFILE}`,
                        sendAuthHeader: true,
                    });

                    const { email, mobile_number, first_name, last_name } =
                        responseProfile;

                    updateEmail(email);
                    updatePhone(mobile_number);
                    updateUserObj({
                        fname: first_name,
                        lname: last_name,
                    });
                    let userDetails = {};
                    userDetails['fname'] = first_name;
                    userDetails['lname'] = last_name;
                    sessionStorage.setItem(
                        sessionStorageKeys.USER_DETAILS,
                        JSON.stringify(userDetails)
                    );
                    sessionStorage.setItem(
                        sessionStorageKeys.USER_PHONE,
                        mobile_number
                    );
                    sessionStorage.setItem(
                        sessionStorageKeys.LOGIN_FROM_DEEP_LINK,
                        false
                    );
                } catch (error) {
                    getErrorNotification(error);
                } finally {
                    destroyAutoLogin();
                }
            }

            setState((prevState) => ({
                ...prevState,
                userNumber: response?.masked_identity,
            }));
        } catch (error) {
            getErrorNotification(error);
        }
    };

    const handleOtpChange = (e) => {
        if (e?.target?.value?.length > 6) {
            setState((prevState) => ({
                ...prevState,
                otpErrorMessage: 'OTP cannot be greater than 6 digits',
                isOtpValid: false,
            }));
            return;
        }
        setState((prevState) => ({
            ...prevState,
            otp: e?.target?.value,
        }));
    };

    const handleCreateAccount = () => {
        sessionStorage.removeItem(sessionStorageKeys.IS_AUTO_LOGIN);
        window.location.href = `/v2/create-account?bckUrl=/home`;
    };

    const closeConfirmationModal = () => {
        setState((prevState) => ({
            ...prevState,
            showLogoutConfirmation: false,
        }));
        localStorage.removeItem(localStorageKeys.SECOND_USER_PHONE);
        localStorage.removeItem(localStorageKeys.SECOND_USER_TOKEN);
    };

    const loginSecondUser = async () => {
        try {
            await post({
                endPoint: APIS.LOGOUT_USER,
                responseType: 'json',
                useLoginApiBase: true,
                sendAuthHeader: true,
            });
            setState((prevState) => ({
                ...prevState,
                showLogoutConfirmation: false,
            }));
            onClickProceedLogin(
                getDecryptedMobileNumber(localStorageKeys.SECOND_USER_PHONE)
            );
            clearUserData();
            clearUserDataFromStorage();
        } catch (error) {
            getErrorNotification(error);
        }
    };

    const renderConfirmationModal = () => {
        const { showLogoutConfirmation } = state;
        return (
            <Modal
                maskClosable={false}
                closable={false}
                open={showLogoutConfirmation}
                footer={null}
                wrapClassName="modal-class"
                onCancel={closeConfirmationModal}
                className="confirmation-modal"
                bodyStyle={{
                    height: 158,
                    borderRadius: 14.25,
                    width: isMobile ? 330 : 345,
                }}
            >
                <div className={`${homeStyles.confirmationModalContainer}`}>
                    {' '}
                    <div
                        className={`${styles.confirmationText}`}
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            marginLeft: '10px',
                        }}
                    >
                        <Image
                            src={warrningIconSVG}
                            style={{
                                marginRight: '10px',
                                marginTop: '4px',
                            }}
                            alt="warrningIcon-image"
                        />
                        <div>
                            We noticed that you have a loan account linked with
                            <span style={{ fontWeight: 'bold' }}>
                                {getDecryptedMobileNumber(
                                    localStorageKeys.SECOND_USER_PHONE
                                )}
                            </span>
                            . Do you wish to login from the same?
                        </div>
                    </div>
                    <div style={{ alignSelf: 'flex-end' }}>
                        <Button
                            text={'No'}
                            className={`${styles.confirmationBtn} ${styles.confirmationSecondary}`}
                            click={closeConfirmationModal}
                            shape="default"
                        />

                        <Button
                            text={'Yes'}
                            className={`${styles.confirmationBtn} ${styles.confirmationPrimary}`}
                            click={loginSecondUser}
                            shape="default"
                        />
                    </div>
                </div>
            </Modal>
        );
    };

    const generateOtpContainer = () => {
        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title}`}>
                    OTP Verification
                </div>
                <br />
                <div className={`${homeStyles.drawer_title_meta}`}>
                    {`Enter the OTP sent to ${
                        state?.userNumber ||
                        getDecryptedMobileNumber(
                            localStorageKeys.SECOND_USER_PHONE
                        )
                    }`}
                </div>
                <br></br>
                <Form.Item
                    validateStatus={!state.isOtpValid ? 'error' : null}
                    help={
                        !state.isOtpValid
                            ? state.otpErrorMessage ||
                              'Please enter a valid OTP'
                            : ''
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Please enter a valid OTP',
                        },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input
                        placeholder="Enter your 6 digit OTP"
                        change={handleOtpChange}
                        type="number"
                        value={state.otp}
                        inputType="login"
                    />
                </Form.Item>
                <div className={styles.createAccountActionOtp}>
                    {`Attempts Left: ${state.countsLeft}`}
                    <span
                        className={` ${
                            state.countsLeft === 0
                                ? styles?.disabledResendButton
                                : styles?.inLineAction
                        }`}
                        onClick={autoLogin}
                        style={{ textDecoration: 'underline' }}
                    >
                        Resend OTP
                    </span>
                </div>
                <br />
                <Button
                    className={styles.cgbtn}
                    text={'Proceed'}
                    click={() => autoLogin('otp')}
                    loading={state.btnLoadingState}
                />

                <br />
                <div
                    className={styles.createAccountAction}
                    style={{ alignSelf: 'center' }}
                >
                    Don’t have an account ?
                    <span
                        className={styles.inLineAction}
                        onClick={handleCreateAccount}
                    >
                        {' '}
                        Create Account
                    </span>
                </div>
            </div>
        );
    };

    const destroyAutoLogin = () => {
        sessionStorage.removeItem(sessionStorageKeys.IS_AUTO_LOGIN);
        setState((prevState) => ({
            ...prevState,
            isOtpModalOpen: false,
            isOtpDrawerOpen: false,
            showAutoLoginPopup: false,
        }));
    };

    const getAutoLoginPopup = () => {
        return (
            <Modal
                open={state.isOtpModalOpen}
                footer={null}
                wrapClassName="modal-class"
                width={542}
                onCancel={destroyAutoLogin}
            >
                {generateOtpContainer()}
            </Modal>
        );
    };

    const getAutoLoginDrawer = () => {
        return (
            <Drawer
                title=""
                placement="bottom"
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '36px',
                }}
                height="360px"
                open={state.isOtpDrawerOpen}
                onClose={destroyAutoLogin}
            >
                {generateOtpContainer()}
            </Drawer>
        );
    };

    return (
        <>
            <Title value="Make secure payments | Billzy" />
            {renderConfirmationModal()}
            {isMobile ? (
                <>{getAutoLoginDrawer()}</>
            ) : (
                <>{getAutoLoginPopup()}</>
            )}

            <HomeCorousel isMobile={isMobile} />
            <br></br>
            <div className={`${homeStyles.categoryContainer}`}>
                <div className={`${homeStyles.loanDetailContainer}`}>
                    <div className={homeStyles.tagLine}>
                        Pay for your loans, securely and instantly!
                    </div>
                    {userLoggedIn && !state.showLoans ? (
                        <div
                            className={`${homeStyles.showLoansContainer}`}
                            onClick={() => {
                                getLinkedLoans();
                                setState((prevState) => ({
                                    ...prevState,
                                    showLoans: true,
                                }));
                                handlEvents({
                                    events: MixPanelEvents['Billzy_show_Loans'],
                                    module: EventProperites[
                                        'Billzy - Show Loans'
                                    ],
                                    category: MixPanelCategory.Exprience,
                                    cta: MixPanelCTA.click,
                                });
                            }}
                        >
                            <div className={homeStyles.showLoansText}>
                                SHOW LOANS
                            </div>
                            <Image
                                src={arrowForwardIsoFilledIcon}
                                alt="arrowForwardIsoFilledIcon-image"
                            />
                        </div>
                    ) : null}
                </div>

                {/* //confirmationTitle */}
                <div className={homeStyles.loanCategoryContainer}>
                    <div className={homeStyles.loanCategoryHeaders}>
                        {state?.checkPointers?.map((pointer, i) => (
                            <div
                                className={homeStyles.checkPointWrapper}
                                key={`pointer_${i + 1}`}
                            >
                                <Image
                                    src={checkedSquareSVG}
                                    style={{ marginTop: '8px' }}
                                    alt="checkedSquare-image"
                                />
                                <div className={homeStyles.pointers}>
                                    {pointer}
                                </div>
                            </div>
                        ))}
                    </div>

                    {userLoggedIn && state.showLoans ? (
                        <div
                            className={homeStyles.loanCategoryDiv}
                            style={{
                                justifyContent:
                                    userLoggedIn && !state.linked_loans?.length
                                        ? 'center'
                                        : '',
                            }}
                        >
                            {state.loading ? (
                                <Skeleton />
                            ) : (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '20px',
                                        paddingRight: '20px',
                                    }}
                                >
                                    {!state.linked_loans?.length ? (
                                        <div className={homeStyles.tagLine}>
                                            No Loans Found
                                        </div>
                                    ) : (
                                        state?.linked_loans?.map((loan, i) => (
                                            <div
                                                className={
                                                    homeStyles.checkAndPayWrapper
                                                }
                                                key={`loan_${i + 1}`}
                                            >
                                                <div
                                                    className={
                                                        homeStyles.checkAndPayWrapperHead
                                                    }
                                                    onClick={() => {
                                                        checkAndPay(loan);
                                                        handlEvents({
                                                            events: MixPanelEvents[
                                                                'Billzy_show_Loans _Check_and_Pay'
                                                            ],
                                                            module: EventProperites[
                                                                'Billzy-Check and Pay'
                                                            ],
                                                            category:
                                                                MixPanelCategory.Exprience,
                                                            cta: MixPanelCTA.click,
                                                        });
                                                    }}
                                                >
                                                    <div
                                                        className={
                                                            homeStyles.checkAndPayText
                                                        }
                                                    >
                                                        Check & Pay
                                                    </div>
                                                    <Image
                                                        src={sideChevronSVG}
                                                        alt="sideChevron-image"
                                                    />
                                                </div>
                                                <div
                                                    className={
                                                        homeStyles.checkAndPayWrapperBody
                                                    }
                                                >
                                                    <div
                                                        className={
                                                            homeStyles.billerName
                                                        }
                                                    >
                                                        {loan?.company_trademark ||
                                                            'N/A'}
                                                    </div>
                                                    <div
                                                        className={
                                                            homeStyles.loanNumber
                                                        }
                                                    >
                                                        {loan?.loan_id || 'N/A'}
                                                    </div>
                                                    <div
                                                        className={
                                                            homeStyles.dpdBracket
                                                        }
                                                    >
                                                        Days Passed Due:{' '}
                                                        {loan?.allocation_dpd_value ||
                                                            'N/A'}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
            <br></br>

            <div>
                <div className={`${homeStyles.howItWorksContainer}`}>
                    <Image
                        src={howItWorks}
                        alt="How it works"
                        style={{
                            width: '100%',
                            height: 'auto',
                        }}
                    />
                </div>
                {/* NOSONAR 
                <div
                    className={`${homeStyles.categoryContainer}`}
                    style={{ display: 'none' }}
                >
                    <div className={`${homeStyles.allCategoryHeading}`}>
                        Recharge and Bill Payments
                    </div>
                    <div className={`${homeStyles.allCategoryItems}`}>
                        {renderReleasedItems()}
                    </div>
                </div> */}
                <br />
                {userLoggedIn && state.transactions.length ? (
                    <div style={{ padding: '20px 0px' }}>
                        <div
                            className={`${homeStyles.allCategoryHeading}`}
                            style={{
                                marginBottom: '20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            Recent Transaction
                            <p
                                className="transaction-detail-payagain"
                                onClick={redirectToTranscations}
                            >
                                View All
                            </p>
                        </div>
                        <TransactionCard transaction={state?.transactions[0]} />
                    </div>
                ) : null}
                {renderStaticPagesContainer()}
            </div>
        </>
    );
};

export default Home;
